import { useMutationEndpoint, UseMutationOptionsFromProvider } from '../../core'
import { postAuthMfaSetupInitiate } from '../endpoints'

type MutationParams = Parameters<typeof postAuthMfaSetupInitiate>[0]

export const useAuthMfaSetupInitiatePostMutation = (
  options?: UseMutationOptionsFromProvider<
    typeof postAuthMfaSetupInitiate,
    MutationParams
  >,
) =>
  useMutationEndpoint(
    (data: MutationParams) => postAuthMfaSetupInitiate(data),
    options,
  )
